import React, { useState ,useEffect} from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { API_URL, LOCATION_ID } from "..";
import { Spinner } from "react-bootstrap";
import ServiceListLayer from "../components/ServiceListLayer";




const ServiceListPage = () => {

  const [data, setData]=useState([])
  const [loading, setLoading]=useState(false)
  const fetchInvoices =  async()=>{
    setLoading(true)
      const user = JSON.parse(localStorage.getItem('user'));
      if(!user){
        window.location.href='/sign-in'
      }else{
        let headersList = {
          "Accept": "*/*",
          "Content-Type": "application/json"
         }
        let response = await fetch( API_URL+`/api/service?locationId=${LOCATION_ID}`, { 
          method: "GET",
          headers: headersList
        });
        const data = await response.json();
        setLoading(false)
        
        setData(data)
      }
      
  }
  useEffect(()=>{
    fetchInvoices();
  },[1])
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Services - List" />

        {/* InvoiceListLayer */}
        {
          loading ===true ?
          <div className="text-center mt-4">
            <Spinner/>
          </div>:null
        }
        {
          data.length === 0 && loading ===false ?
          <div className="text-center mt-4">
            <p>No Services data found....</p>
          </div>:null
        }
        {
          data.length== 0 ? null :
          <ServiceListLayer jobsData={data}/>
        }

      </MasterLayout>

    </>
  );
};

export default ServiceListPage;
